import { useEffect, useRef } from "react";

export default function HeroSection() {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = true;
    video.setAttribute("webkit-playsinline", "");
    video.setAttribute("playsinline", "");
    const tryPlay = () => {
      video.currentTime = 0;
      video.play().catch(() => {});
    };
    video.addEventListener("loadedmetadata", tryPlay, { once: true });
    video.addEventListener("canplay", tryPlay, { once: true });
    tryPlay();
    return () => {
      video.removeEventListener("loadedmetadata", tryPlay);
      video.removeEventListener("canplay", tryPlay);
    };
  }, []);

  return (
    <section className="relative w-full overflow-hidden h-[100dvh]">
      <video
        ref={videoRef}
        src="/hero.mp4"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        className="absolute inset-0 w-full h-full object-cover [transform:scale(1.25)] [transform-origin:center] md:[transform:scale(1.25)] md:[transform-origin:center]"
      />
    </section>
  );
}
